import { useCallback, useMemo, useSyncExternalStore } from "react";
import {
  DESKTOP_BREAKPOINT,
  TABLET_BREAKPOINT,
  SMALL_MOBILE_BREAKPOINT,
} from "../utils/variables";
import { toPx } from "../utils/toPx";

export const MediaQuery = {
  isDesktop: `(min-width: ${toPx(DESKTOP_BREAKPOINT)})`,
  isCompact: `(max-width: 819px)`,
  isSmallMobile: `(max-width: ${toPx(SMALL_MOBILE_BREAKPOINT - 1)})`,
  isMobile: `(max-width: ${toPx(TABLET_BREAKPOINT - 1)})`,
  isTablet: `(min-width: ${toPx(TABLET_BREAKPOINT)}) and (max-width: ${toPx(
    DESKTOP_BREAKPOINT - 1
  )})`,
};

const getServerSnapshot = () => false;

export const useDeviceType = (query) => {
  const media = useMemo(
    () =>
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query)
        : null,
    [query]
  );

  const subscribe = useCallback(
    (onChange) => {
      if (!media) return () => {};
      media.addEventListener("change", onChange);
      return () => media.removeEventListener("change", onChange);
    },
    [media]
  );
  const getSnapshot = useCallback(() => media?.matches ?? false, [media]);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
